import { render, staticRenderFns } from "./hospitalList.vue?vue&type=template&id=f705bfea"
import script from "./hospitalList.vue?vue&type=script&lang=js"
export * from "./hospitalList.vue?vue&type=script&lang=js"
import style0 from "./hospitalList.vue?vue&type=style&index=0&id=f705bfea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports